export default __webpack_public_path__ + "static/media/company-testimonial-1.adcd9a92.jpg";